import { installedTemplateAdapter } from 'apps/templates/models/Template/adapter'
import { mapResponse } from 'shared/api/lib/mapResponse'
import { templatesApi } from 'shared/api/requests/templates'
import { createListSlice } from 'shared/lib/factory/redux/createListSlice'
import { createListOperations } from 'shared/lib/factory/redux/createListSlice/lib/createListOperations'
import { createAsyncAction } from 'shared/lib/redux'

const Namespace = 'templates'
const InstalledTemplatesList = `${Namespace}InstalledList`

const {
  reducer: installedTemplatesReducer,
  actions: installedTemplatesActions,
  selectors: installedTemplatesSelectors,
} = createListSlice({
  namespace: InstalledTemplatesList,
  storePath: `${Namespace}.installed`,
  listKey: `installationId`,

  operations: createListOperations({
    getList: mapResponse(templatesApi.fetch, (response) =>
      response.data.templates.map((template) => installedTemplateAdapter(template)),
    ),
    getNextList: undefined,
    getPrevList: undefined,
    createItem: undefined,
    updateItem: undefined,
    deleteItem: undefined,
  }),

  getItemId: (template) => template?.installationId ?? NaN,

  reducers: {},
  extraState: {},
})

const { getList } = installedTemplatesSelectors
const { getListFx, deleteItem: deleteInstalledTemplates } = installedTemplatesActions

const deleteInstalledTemplateNotification = createAsyncAction(
  `${InstalledTemplatesList}/deleteInstalledTemplateNotification`,
  (id: number, { dispatch }) => {
    dispatch(deleteInstalledTemplates({ id }))
  },
)

const getInstalledTemplates = createAsyncAction(
  `${InstalledTemplatesList}/getInstalledTemplates`,
  async (hash: string | null, { dispatch }) => {
    const response = await dispatch(getListFx({ payload: { query: { hash } } }))
    return response.payload
  },
)

export const forceFetchInstalledTemplates = createAsyncAction(
  `${InstalledTemplatesList}/forceFetchInstalledTemplates`,
  async (_, { dispatch, getState }) => {
    const state = getState().templates

    if (!state.currentInstalled.item) {
      dispatch(getInstalledTemplates(null))
      return
    }

    const installationId = state.currentInstalled.item.installationId
    const hasChanges =
      state.installed.byId[installationId] &&
      state.currentInstalled.item.isProtected !== state.installed.byId[installationId].isProtected
    const fakeHash = String(Math.random() * 100)

    dispatch(getInstalledTemplates(hasChanges ? fakeHash : null))
  },
)

export { installedTemplatesReducer, deleteInstalledTemplateNotification, getList }
